(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slick-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.sliderContainer').each(function () {
    var $el = $(this);
    if ($el.hasClass('slick-initialized')) return;

    var desktop = parseInt(this.dataset.slidesDesktop, 10) || 5;
    var tablet = parseInt(this.dataset.slidesTablet, 10) || 3;
    var mobile = parseInt(this.dataset.slidesMobile, 10) || 1;

    $el.slick({
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: desktop,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 999,
          settings: {
            slidesToShow: tablet,
            slidesToScroll: 1,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 739,
          settings: {
            slidesToShow: mobile,
            slidesToScroll: 1
          }
        }
      ]
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
